import { ScheduleGridHeaderCellProps } from '@intrasync/react';

interface ProductionScheduleRightHeaderCellProps
  extends ScheduleGridHeaderCellProps {
  currentHeader: {
    title: string;
  };
}

const ProductionScheduleRightHeaderCell = (
  props: ProductionScheduleRightHeaderCellProps
) => {
  // console.log('props', props);
  const { currentHeader } = props;
  return (
    <div
      style={{
        border: '1px solid #eee',
        ...props.style,
        ...props.styles,
      }}
    >
      <b>Form {currentHeader?.title}</b>
    </div>
  );
};

export default ProductionScheduleRightHeaderCell;
